import { mutateGraphQL } from "~/hooks/graphql";

const ChangeCountryMutation = `
  mutation ChangeCountry($countryCode: String!) {
    updateCountry(input: { countryCode: $countryCode }) {
      status
      currencyCode
      isEuCountry
      isEuVerifyRequired
    }
  }
`;

export const getChangeCountryMutationHandler = () => {
  const allData = mutateGraphQL(ChangeCountryMutation);

  return { mutationHandler: allData.mutationHandler };
}